import { EventBus } from "@/eventBus";

// Diagnostics must never change the call or status-save workflow.
export function logShortCallModal(phase, offer, details = {}) {
  if (!offer || !offer.orderId) return;
  try {
    const mode = details.automatic === true ? "automatic" : details.automatic === false ? "manual" : null;
    const reason = typeof details.reason === "string" && /^[a-z_]+$/.test(details.reason) ? details.reason : null;
    EventBus.$emit("cabinet-log", {
      // WS already persists eventName and the authenticated operator identity.
      eventName: ["short-call.modal", phase, "order", offer.orderId, mode, reason].filter(Boolean).join("."),
      createdAt: new Date().toISOString(),
      source: "short-call-modal",
      orderId: offer.orderId,
      clientCallId: offer.clientCallId || null,
      callDurationSeconds: offer.durationSeconds,
      callStartedAt: Number.isFinite(offer.startedAt) ? new Date(offer.startedAt).toISOString() : null,
      callEndedAt: Number.isFinite(offer.finishedAt) ? new Date(offer.finishedAt).toISOString() : null,
      suggestedSubStatusId: offer.suggestedSubStatus,
      selectedSubStatusId: details.subStatusId || null,
      automatic: mode ? details.automatic : null,
      reason,
      phoneHasActiveCall: details.phoneHasActiveCall === true,
      httpStatus: Number.isInteger(details.httpStatus) ? details.httpStatus : null,
    });
  } catch (_) { /* Logging is best effort, never a save prerequisite. */ }
}
